<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="tabs">
				<div class="top_input2">
					<el-select v-model="checkType" placeholder="请选择" @change="checkTypeChange">
						<el-option label="运单号" value="1"> </el-option>
						<el-option label="托运商" value="2"> </el-option>
						<el-option label="车牌号" value="3"> </el-option>
						<el-option label="驾驶员" value="4"> </el-option>
						<el-option label="押运员" value="5"> </el-option>
						<el-option label="装货地" value="6"> </el-option>
						<el-option label="卸货地" value="7"> </el-option>
					</el-select>
				</div>
				<div class="top_input3">
					<el-select v-model="checkTypeValue" filterable placeholder="请选择" clearable v-if="checkType!=='1'">
						<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
							:value="item.index">
							<!-- <span style="float: left">{{ item.value }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.index }}
						</span> -->
						</el-option>
					</el-select>
					<el-input type="text" placeholder="请输入" v-model="searchWord" v-if="checkType=='1'"></el-input>
				</div>
				<div
					style="display: flex;width: 230px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;padding: 0 10px;">
					所属月份：
					<el-date-picker style="width: 150px; height: 35px" v-model="monthStr" type="month" placeholder="选择月"
						:clearable="false" @change="getMonth">
					</el-date-picker>
				</div>
				<div
					style="display: flex;width: 350px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;">
					计划装货时间：
					<el-date-picker style="width: 250px; height: 35px" v-model="pLoaddayArr" type="datetimerange"
						range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
						format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
					</el-date-picker>
				</div>
				<div style="display: flex;width: 350px; height: 35px;align-items: center;justify-content: flex-start;">
					卸货离站时间：
					<el-date-picker style="width: 250px; height: 35px" v-model="sUnlonddayArr" type="datetimerange"
						range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
						format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
					</el-date-picker>
				</div>
				<div class="search_btn" @click="getData">查询</div>
				<div class="search_btn" @click="exportClick()" v-if="permissionItem.export">导出</div>
			</div>
			<div class="close_button">
				<el-popover :visible="popoverVisible" @show="showPopover" placement="bottom" trigger="click"
					:width="200">
					<div style="max-height: 300px; overflow-y: auto;">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
							@change="handleCheckAllChange">全选</el-checkbox>
						<div style="margin: 10px 0;"></div>
						<el-checkbox-group v-model="checkedColumns" @change="handleCheckedColumnsChange"
							style="display: flex;flex-direction: column;">
							<el-checkbox v-for="column in columns" :label="column.lable"
								:key="column.lable">{{column.lable}}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div style="text-align: right; margin: 0">
						<el-button size="small" text @click="popoverVisible = false">取消</el-button>
						<el-button size="small" type="primary" @click="confirmPopover">
							确认
						</el-button>
					</div>
					<template #reference>
						<!-- <el-button @click="visible = true">列设置</el-button> -->
						<div @click="popoverVisible = true">
							<i class="iconfont icon-shezhi"> 列设置</i>
						</div>
					</template>
				</el-popover>
			</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" highlight-current-row ref="tableRef" :key="tableKey" @current-change="handleCurrentChange">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column fixed prop="lorId" label="运单号" v-if="showColumn('运单号')"
						width="120"></el-table-column>
					<el-table-column fixed prop="lorVehHeadNo" label="牵引车辆" v-if="showColumn('牵引车辆')"
						width="120"></el-table-column>
					<el-table-column fixed prop="shipperName" label="托运商" v-if="showColumn('托运商')"
						width="120"></el-table-column>
					<!-- <el-table-column prop="supplierName" label="承运商" width="120"></el-table-column> -->
					<el-table-column fixed prop="lorLoadName" label="装货地" v-if="showColumn('装货地')"
						width="120"></el-table-column>
					<el-table-column fixed prop="lorLoadpTime" label="计划装货时间" v-if="showColumn('计划装货时间')"
						width="120"></el-table-column>
					<el-table-column prop="lorLoadsTime" label="装货到站时间" v-if="showColumn('装货到站时间')"
						width="120"></el-table-column>
					<el-table-column prop="lorLoadStartTime" label="装货开始时间" v-if="showColumn('装货开始时间')"
						width="120"></el-table-column>
					<el-table-column prop="lorLoadOffsiteTime" label="装货离站时间" v-if="showColumn('装货离站时间')"
						width="120"></el-table-column>
					<el-table-column prop="lorLoadsWeightSum" label="实际装货吨位" v-if="showColumn('实际装货吨位')"
						width="120"></el-table-column>
					<el-table-column prop="lorUnlName" label="卸货地" v-if="showColumn('卸货地')"
						width="120"></el-table-column>
					<el-table-column prop="unloadList[0].lorlUnlpTime" label="计划卸货时间" v-if="showColumn('计划卸货时间')"
						width="120"></el-table-column>
					<el-table-column prop="unloadList[0].lorlUnlsTime" label="卸货到站时间" v-if="showColumn('卸货到站时间')"
						width="120"></el-table-column>
					<el-table-column prop="unloadList[0].lorlUnlStartTime" label="卸货开始时间" v-if="showColumn('卸货开始时间')"
						width="120"></el-table-column>
					<el-table-column prop="unloadList[0].lorlUnlOffsiteTime" label="卸货离站时间" v-if="showColumn('卸货离站时间')"
						width="120"></el-table-column>
					<el-table-column prop="lorUnlpWeightSum" label="计划卸货吨位" v-if="showColumn('计划卸货吨位')"
						width="120"></el-table-column>
					<el-table-column prop="lorUnlsWeightSum" label="实际卸货吨位" v-if="showColumn('实际卸货吨位')"
						width="120"></el-table-column>
					<el-table-column prop="lorLossWeightSum" label="途损量（吨）" v-if="showColumn('途损量（吨）')"
						width="120"></el-table-column>
					<el-table-column prop="lorUnlsWeightSum" label="核算量（吨）" v-if="showColumn('核算量（吨）')"
						width="120"></el-table-column>
					<el-table-column prop="freewayCost" label="成本-高速费" v-if="showColumn('成本-高速费')"
						width="120"></el-table-column>
					<el-table-column prop="tollCost" label="成本-路桥费" v-if="showColumn('成本-路桥费')"
						width="120"></el-table-column>
					<el-table-column prop="fuelCost" label="成本-燃料费" v-if="showColumn('成本-燃料费')"
						width="120"></el-table-column>
					<el-table-column prop="maintenanceCost" label="成本-维修费" v-if="showColumn('成本-维修费')"
						width="120"></el-table-column>
					<el-table-column prop="parkingCost" label="成本-停车费" v-if="showColumn('成本-停车费')"
						width="120"></el-table-column>
					<el-table-column prop="insuSharCost" label="成本-保险分推费"
						v-if="showColumn('成本-保险分推费')"></el-table-column>
					<el-table-column prop="safetyCost" label="成本-安全费" v-if="showColumn('成本-安全费')"
						width="120"></el-table-column>
					<el-table-column prop="depreciationCost" label="成本-折旧费" v-if="showColumn('成本-折旧费')"
						width="120"></el-table-column>
					<el-table-column prop="otherCost" label="成本-其他费" v-if="showColumn('成本-其他费')"
						width="120"></el-table-column>
					<el-table-column prop="mdriveSalary" label="成本-驾驶员薪资" v-if="showColumn('成本-驾驶员薪资')"
						width="120"></el-table-column>
					<el-table-column prop="yayunSalary" label="成本-押运员薪资" v-if="showColumn('成本-押运员薪资')"
						width="120"></el-table-column>
					<el-table-column prop="lorVehTailNo" label="挂车辆" v-if="showColumn('挂车辆')"
						width="120"></el-table-column>
					<el-table-column prop="odrMDirName" label="驾驶员" v-if="showColumn('驾驶员')"
						width="120"></el-table-column>
					<el-table-column prop="odrYayunName" label="押运员" v-if="showColumn('押运员')"
						width="120"></el-table-column>
					<el-table-column prop="lorGoods" label="货品" v-if="showColumn('货品')" width="120">
						<template #default="scope">
							<span v-if="scope.row.lorGoods == '1'">LNG</span>
							<span v-else-if="scope.row.lorGoods == '2'">CNG</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="lorLoadType" label="单/分卸" v-if="showColumn('单/分卸')" width="120">
						<template #default="scope">
							<span v-if="scope.row.lorLoadType == '0'">单装单卸</span>
							<span v-else-if="scope.row.lorLoadType == '1'">单装分卸</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="freightPrice" label="运输单价（元/吨/公里）" v-if="showColumn('运输单价（元/吨/公里）')"
						width="120"></el-table-column>
					<el-table-column prop="freightMilage" label="运费里程(KM)" v-if="showColumn('运费里程(KM)')"
						width="120"></el-table-column>
					<el-table-column prop="sumIncome" label="运费收入(元)" v-if="showColumn('运费收入(元)')"
						width="120"></el-table-column>
					<el-table-column prop="occupyIncome" label="压车费收入(元)" v-if="showColumn('压车费收入(元)')"
						width="120"></el-table-column>
					<el-table-column prop="unloadIncome" label="分卸费收入(元)" v-if="showColumn('分卸费收入(元)')"
						width="120"></el-table-column>
					<el-table-column prop="sumCost" label="运费成本(元)" v-if="showColumn('运费成本(元)')"
						width="120"></el-table-column>
					<!-- <el-table-column prop="roleCreName" label="毛利润" width="120"></el-table-column> -->
					<el-table-column prop="sumMoney" label="运费利润(元)" v-if="showColumn('运费利润(元)')"
						width="120"></el-table-column>
					<el-table-column prop="monthly" label="所属月份" v-if="showColumn('所属月份')"
						width="120"></el-table-column>
					<!-- <el-table-column label="操作" fixed="right" width="100px">
						<template #default="scope">
							<span class="default_color pointer m-right10"
								v-on:click="detail(scope.row.roleId)">详情</span>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-around">
				<div style="font-size: 14px; display: inline-block">
					运单总量:<span style="color: red">{{ sumYundanCount }}单</span>，总卸货量：<span
						style="color: red">{{ sumFreightWeight.toFixed(2) }}吨</span>，总途损量：<span
						style="color: red">{{ sumLossWeight.toFixed(2) }}吨</span>，总里程：<span
						style="color: red">{{ sumFreightMilage }}公里</span>，总运费：<span
						style="color: red">{{ sumMoney.toFixed(2) }}元</span>
				</div>
				<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
					:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper" :total="totalCount"
					@size-change="getData" @current-change="getData" />
			</div>
		</div>

		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		name: "ledgerManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const popoverVisible = ref(false);
			const checkAll = ref(true);
			const tableKey = ref(0) // 关键：用于强制重新渲染
			// 选择展示的字段数组默认的
			const columns = ref([{
					lable: '运单号',
					show: true
				},
				{
					lable: '牵引车辆',
					show: true
				},
				{
					lable: '托运商',
					show: true
				},
				{
					lable: '装货地',
					show: true
				},
				{
					lable: '计划装货时间',
					show: true
				},
				{
					lable: '装货到站时间',
					show: true
				},
				{
					lable: '装货开始时间',
					show: true
				},
				{
					lable: '装货离站时间',
					show: true
				},
				{
					lable: '实际装货吨位',
					show: true
				},
				{
					lable: '卸货地',
					show: true
				},
				{
					lable: '计划卸货时间',
					show: true
				},
				{
					lable: '卸货到站时间',
					show: true
				},
				{
					lable: '卸货开始时间',
					show: true
				},
				{
					lable: '卸货离站时间',
					show: true
				},
				{
					lable: '计划卸货吨位',
					show: true
				},
				{
					lable: '实际卸货吨位',
					show: true
				},
				{
					lable: '途损量（吨）',
					show: true
				},
				{
					lable: '核算量（吨）',
					show: true
				},
				{
					lable: '成本-高速费',
					show: true
				},
				{
					lable: '成本-路桥费',
					show: true
				},
				{
					lable: '成本-燃料费',
					show: true
				},
				{
					lable: '成本-维修费',
					show: true
				},
				{
					lable: '成本-停车费',
					show: true
				},
				{
					lable: '成本-保险分推费',
					show: true
				},
				{
					lable: '成本-安全费',
					show: true
				},
				{
					lable: '成本-折旧费',
					show: true
				},
				{
					lable: '成本-其他费',
					show: true
				},
				{
					lable: '成本-驾驶员薪资',
					show: true
				},
				{
					lable: '成本-押运员薪资',
					show: true
				},
				{
					lable: '挂车辆',
					show: true
				},
				{
					lable: '驾驶员',
					show: true
				},
				{
					lable: '押运员',
					show: true
				},
				{
					lable: '货品',
					show: true
				},
				{
					lable: '单/分卸',
					show: true
				},
				{
					lable: '运输单价（元/吨/公里）',
					show: true
				},
				{
					lable: '运费里程(KM)',
					show: true
				},
				{
					lable: '运费收入(元)',
					show: true
				},
				{
					lable: '压车费收入(元)',
					show: true
				},
				{
					lable: '分卸费收入(元)',
					show: true
				},
				{
					lable: '运费成本(元)',
					show: true
				},
				{
					lable: '运费利润(元)',
					show: true
				},
				{
					lable: '所属月份',
					show: true
				}
			]);

			const checkedColumns = ref([]) //选中的数据
			const isIndeterminate = ref(false)
			//表格实例
			const tableRef = ref(null)
			const currentRow = ref()

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				checkType: "1",
				checkCostStatus: "",
				pLoaddayArr: [],
				sUnlonddayArr: [],
				checkTypeValue: "",
				checkTypeList: [],
				lorId: "",
				lorShipper: "",
				vehHeadNo: "",
				driverId: "",
				lorYayunId: "",
				lorLoadWhid: "",
				lorlUnlWhid: "",
				monthStr: "",
				sumYundanCount: 0, //汇总运单量
				sumLossWeight: 0, //汇总途损量
				sumFreightWeight: 0, //汇总卸货量
				sumFreightMilage: 0, //汇总里程
				sumMoney: 0, //汇总运费

				permissionItem: {
					list: false,
					export: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "ledgerManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "ledgerManage:export") {
						data.permissionItem.export = true;
					}
				});
				// 强制表格重新渲染
				tableKey.value++

				var d = new Date();
				var year = d.getFullYear();
				var month = d.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				data.monthStr = year + "-" + month;

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
					gettableColumn();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});

			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询单趟台账权限！");
					return;
				}

				data.sumYundanCount = 0;
				data.sumLossWeight = 0;
				data.sumFreightWeight = 0;
				data.sumFreightMilage = 0;
				data.sumMoney = 0;

				setParameter(); //设置查询参数

				let params = {
					page: data.page,
					limit: data.pageSize,
					date: data.monthStr + '-01',
					lorId: data.lorId, //运单号
					lorShipper: data.lorShipper, //托运商ID 必填
					vehHeadNo: data.vehHeadNo, //车牌号 必填
					driverId: data.driverId, //驾驶员ID 必填
					lorYayunId: data.lorYayunId, //押运员ID 必填
					lorLoadWhid: data.lorLoadWhid, //装货站点 必填
					lorlUnlWhid: data.lorlUnlWhid, //卸货站点ID 必填
					loadpStartTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						0] : "", //计划装货开始时间
					loadpEndTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						1] : "", //计划装货结束时间
					unlOffsiteStartTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[0] : "", //卸货离站开始时间
					unlOffsiteEndTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[1] : "", //卸货离站结束时间
				};
				const r = await proxy.$http.get(apiObj.transLedgerByOrder, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					data.tableData = r.rows;
					data.totalCount = r.total;

					getListSum(); //获取汇总统计数据
				}
			};

			//获取显示列设置
			const gettableColumn = async () => {

				let params = {
					type: 'ledgerManage',
				};
				const r = await proxy.$http.get(apiObj.tableColumnGet, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					if (r.data !== null && r.data !== undefined && r.data != "") {
						const array = JSON.parse(r.data.utbcColumns);
						let selectedItem = null;

						columns.value.forEach(item1 => {
							selectedItem = array.find(item => item.lable === item1.lable);
							if (selectedItem) {
								item1.show = selectedItem.show;
							}
							// if (array.some(item2 => item2.lable === item1.lable)) {
							// 	item1.show = item2.show;
							//columns.value.push(item1); // 添加到array2中
							//}
						});

						// columns.value.forEach(item => {
						// 	if (checkedColumns.value.some((el) => el == item.lable)) {
						// 		item.show = true;
						// 	} else {
						// 		item.show = false;
						// 	}
						// })
					}
				}
			};

			//更新显示列设置
			const updatetableColumn = async () => {

				let params = {
					utbcType: 'ledgerManage',
					utbcColumns: JSON.stringify(columns.value),
				};
				const r = await proxy.$http.post(apiObj.tableColumnUpdate, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					proxy.$message.success(r.msg || r.respMsg);
				}
			};

			//导出数据
			const exportClick = async () => {
				if (!data.permissionItem.export) {
					proxy.$message.error("没有单趟台账导出权限！");
					return;
				}

				setParameter(); //设置查询参数

				let params = {
					date: data.monthStr + '-01',
					lorId: data.lorId, //运单号
					lorShipper: data.lorShipper, //托运商ID 必填
					vehHeadNo: data.vehHeadNo, //车牌号 必填
					driverId: data.driverId, //驾驶员ID 必填
					lorYayunId: data.lorYayunId, //押运员ID 必填
					lorLoadWhid: data.lorLoadWhid, //装货站点 必填
					lorlUnlWhid: data.lorlUnlWhid, //卸货站点ID 必填
					loadpStartTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						0] : "", //计划装货开始时间
					loadpEndTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						1] : "", //计划装货结束时间
					unlOffsiteStartTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[0] : "", //卸货离站开始时间
					unlOffsiteEndTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[1] : "", //卸货离站结束时间
				};

				const r = await proxy.$http.downloadPostFormData(apiObj.exportTransLedgerByOrder, params,
					"单趟台账数据");
				console.log(r);
			};

			//获取汇总统计数据
			const getListSum = async () => {

				setParameter(); //设置查询参数

				let params = {
					page: data.page,
					limit: data.pageSize,
					date: data.monthStr + '-01',
					lorId: data.lorId, //运单号
					lorShipper: data.lorShipper, //托运商ID 必填
					vehHeadNo: data.vehHeadNo, //车牌号 必填
					driverId: data.driverId, //驾驶员ID 必填
					lorYayunId: data.lorYayunId, //押运员ID 必填
					lorLoadWhid: data.lorLoadWhid, //装货站点 必填
					lorlUnlWhid: data.lorlUnlWhid, //卸货站点ID 必填
					loadpStartTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						0] : "", //计划装货开始时间
					loadpEndTime: data.pLoaddayArr && data.pLoaddayArr.length > 0 ? data.pLoaddayArr[
						1] : "", //计划装货结束时间
					unlOffsiteStartTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[0] : "", //卸货离站开始时间
					unlOffsiteEndTime: data.sUnlonddayArr && data.sUnlonddayArr.length > 0 ? data
						.sUnlonddayArr[1] : "", //卸货离站结束时间
				};

				const r = await proxy.$http.get(apiObj.transLedgerByOrderSum, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.sumYundanCount = r.odrCount; //汇总运单量
					data.sumLossWeight = r.lossWeightSum; //汇总途损量
					data.sumFreightWeight = r.sumFreightWeight; //汇总卸货量
					data.sumFreightMilage = r.sumFreightMilage; //汇总里程
					data.sumMoney = r.sumFreightMoney; //汇总运费
				}

			};

			//设置查询参数
			const setParameter = () => {
				if (data.checkType == "1") {
					data.lorId = data.searchWord;
					data.lorShipper = "";
					data.vehHeadNo = "";
					data.driverId = "";
					data.lorYayunId = "";
					data.lorLoadWhid = "";
					data.lorlUnlWhid = "";
				} else if (data.checkType == "2") {
					data.lorId = "";
					data.lorShipper = data.checkTypeValue;
					data.vehHeadNo = "";
					data.driverId = "";
					data.lorYayunId = "";
					data.lorLoadWhid = "";
					data.lorlUnlWhid = "";
				} else if (data.checkType == "3") {
					data.lorId = "";
					data.lorShipper = "";
					data.vehHeadNo = data.checkTypeValue;
					data.driverId = "";
					data.lorYayunId = "";
					data.lorLoadWhid = "";
					data.lorlUnlWhid = "";
				} else if (data.checkType == "4") {
					data.lorId = "";
					data.lorShipper = "";
					data.vehHeadNo = "";
					data.driverId = data.checkTypeValue;
					data.lorYayunId = "";
					data.lorLoadWhid = "";
					data.lorlUnlWhid = "";
				} else if (data.checkType == "5") {
					data.lorId = "";
					data.lorShipper = "";
					data.vehHeadNo = "";
					data.driverId = "";
					data.lorYayunId = data.checkTypeValue;
					data.lorLoadWhid = "";
					data.lorlUnlWhid = "";
				} else if (data.checkType == "6") {
					data.lorId = "";
					data.lorShipper = "";
					data.vehHeadNo = "";
					data.driverId = "";
					data.lorYayunId = "";
					data.lorLoadWhid = data.checkTypeValue;
					data.lorlUnlWhid = "";
				} else if (data.checkType == "7") {
					data.lorId = "";
					data.lorShipper = "";
					data.vehHeadNo = "";
					data.driverId = "";
					data.lorYayunId = "";
					data.lorLoadWhid = "";
					data.lorlUnlWhid = data.checkTypeValue;
				}
			};


			//菜单删除
			const del = (roleId) => {
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							roleId: roleId,
						};
						const r = await proxy.$http.post(apiObj.roleDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const getMonth = (ev) => {
				var date = new Date(ev);
				var y = date.getFullYear();
				var month = date.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}

				data.monthStr = y + "-" + month;

			};

			const checkTypeChange = async (value) => {
				data.checkTypeValue = "";
				if (value == "2") {
					//获取托运商
					let params = {
						page: 1,
						limit: 10000,
						searchWord: "",
						cocOrg: "",
						cocType: 1,
					};
					const res = await proxy.$http.get(apiObj.cusList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode == "0000") {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.cocName,
								index: el.cocId,
							});
						});

					}
				} else if (value == "3") {
					//获取车辆
					let params = {
						searchWord: "",
						page: 1,
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.vehicleList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.vehHeadNo,
								index: el.vehHeadNo,
							});
						});
					}
				} else if (value == "4") {
					//获取驾驶员
					let params = {
						searchWord: "",
						offset: "0",
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.drigetList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.driList.forEach((el) => {
							data.checkTypeList.push({
								value: el.driName,
								index: el.driUserId,
							});
						});
					}
				} else if (value == "5") {
					//获取押运员
					let params = {
						searchWord: "",
						offset: "0",
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.yygetList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.driList === 0 || res.respCode === '0000') {
						res.yayunList.forEach((el) => {
							data.checkTypeList.push({
								value: el.yyName,
								index: el.yyUserId,
							});
						});
					}
				} else if (value == "6") {
					//获取装货点
					let params = {
						searchWord: "",
						offset: "0",
						limit: "10000",
						whType: 'gsloa'
					};
					const res = await proxy.$http.get(apiObj.siteList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.whName,
								index: el.whId,
							});
						});
					}
				} else if (value == "7") {
					//获取卸货点
					let params = {
						searchWord: "",
						offset: "0",
						limit: "10000",
						whType: 'gsunl'
					};
					const res = await proxy.$http.get(apiObj.siteList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.whName,
								index: el.whId,
							});
						});
					}
				}

			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			// 点击弹出框的“全选”按钮
			const handleCheckAllChange = (val) => {
				let columnsValueList = [];
				columns.value.map(item => columnsValueList.push(item.lable));
				checkedColumns.value = val ? columnsValueList : [];
				isIndeterminate.value = false;
			};
			// 点击弹出框的选择展示菜单的复选框
			const handleCheckedColumnsChange = (value) => {
				let checkedCount = value.length;
				checkAll.value = checkedCount === columns.value.length;
				isIndeterminate.value = checkedCount > 0 && checkedCount < columns.value.length;
			};

			// 弹出框打开时触发
			const showPopover = () => {
				// 选中目前已展示的字段值
				checkedColumns.value = [];
				columns.value.map((item) => {
					if (item.show) {
						checkedColumns.value.push(item.lable);
					}
				});
				// 如果目前展示的是全部字段，则需要勾选上“全选”按钮
				if (columns.value.length == checkedColumns.value.length) {
					checkAll.value = true;
					isIndeterminate.value = false;
				} else {
					isIndeterminate.value = true;
				}

				// 重新渲染表格
				nextTick(() => {
					tableRef.value.doLayout();
				})
			};

			// 表格列是否显示的方法
			const showColumn = (currentColumn) => {
				const column = columns.value.find((item) => item.lable === currentColumn);
				if (column) {
					return column.show;
				} else {
					//console.error(`Column with label "${currentColumn}" not found.`);
					//return undefined; // 或者您可以选择抛出一个错误
					return false;
				}
			};
			// 点击弹出框的“确定”按钮
			const confirmPopover = () => {
				//选择不能没有,需要可放开注释
				// if(checkedColumns.value.length == 0) {
				//   ElMessage.error('请选择需要展示的表格字段')
				//     return;
				// }
				// 根据选择结果，遍历修改列是否展示的属性值
				columns.value.forEach(item => {
					if (checkedColumns.value.some((el) => el == item.lable)) {
						item.show = true;
					} else {
						item.show = false;
					}
				})
				popoverVisible.value = false;
				// 重新渲染表格
				nextTick(() => {
					tableRef.value.doLayout();
					updatetableColumn(); //更新保存

				})
			};
			
			const handleCurrentChange = (val) => {
			  currentRow.value = val
			};

			return {
				...toRefs(data),
				getData,
				del,
				getMonth,
				checkTypeChange,
				timeDeltaCount,
				exportClick,
				columns,
				tableRef,
				isIndeterminate,
				checkedColumns,
				checkAll,
				popoverVisible,
				handleCheckAllChange,
				handleCheckedColumnsChange,
				showPopover,
				showColumn,
				confirmPopover,
				tableKey,
				handleCurrentChange,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.tabs {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	.close_button {
		width: 100px;
		height: 100%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>